import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ForceUpdateOverlay } from '@shared/ui/force-update-overlay/force-update-overlay';

@Component({
  selector: 'app-root',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterOutlet, ForceUpdateOverlay],
  templateUrl: './app.html',
})
export class App {}
